import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";
import { sweetConfirm } from "../utils/sweetAlerts";

const API = "";

function CourseModuleManager() {
  const [academyCategories, setAcademyCategories] = useState([]);
  const [form, setForm] = useState({ academy_category: "", name: "", description: "", is_active: true });
  const [editingId, setEditingId] = useState(null);
  const [filters, setFilters] = useState({ academy_category: "", search: "", status: "" });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const loadRows = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/course-modules-admin`, { params: filters });
      setRows(res.data || []);
    } catch (error) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    axios.get(`${API}/api/academy-categories`).then((res) => setAcademyCategories(res.data || []));
    loadRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await axios.post(editingId ? `${API}/api/course-modules-admin/${editingId}` : `${API}/api/course-modules-admin`, {
        ...form,
        is_active: form.is_active ? 1 : 0,
      });
      setForm({ academy_category: "", name: "", description: "", is_active: true });
      setEditingId(null);
      loadRows();
      alert(editingId ? "Course module updated successfully." : "Course module saved successfully.");
    } catch (error) {
      alert(error.response?.data?.message || "Failed to save course module.");
    } finally {
      setSaving(false);
    }
  };

  const deleteItem = async (id) => {
    if (!(await sweetConfirm("Are you sure you want to delete this course module?", { confirmButtonText: "Yes, Delete" }))) return;
    try {
      await axios.delete(`${API}/api/course-modules-admin/${id}`);
      if (editingId === id) {
        setEditingId(null);
        setForm({ academy_category: "", name: "", description: "", is_active: true });
      }
      await loadRows();
      alert("Course module deleted successfully.");
    } catch (error) {
      alert(error.response?.data?.message || "Failed to delete course module.");
    }
  };

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-body">
            <h3 className="mb-1">Course Module</h3>
            <p className="text-muted mb-4">প্রথমে static academy category select হবে, তারপর সেই academy এর under এ course module create হবে।</p>
            <form onSubmit={submit}>
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">Static Academy Category</label>
                  <select className="form-select" value={form.academy_category} onChange={(e) => setForm((prev) => ({ ...prev, academy_category: e.target.value }))} required>
                    <option value="">Select Academy Category</option>
                    {academyCategories.map((item) => <option key={item} value={item}>{item}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Module Name</label>
                  <input className="form-control" value={form.name} onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))} required />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Description</label>
                  <input className="form-control" value={form.description} onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))} />
                </div>
              </div>
              <div className="mt-3 d-flex align-items-center gap-3 flex-wrap">
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" checked={form.is_active} onChange={(e) => setForm((prev) => ({ ...prev, is_active: e.target.checked }))} />
                  <label className="form-check-label">{form.is_active ? "Active" : "Inactive"}</label>
                </div>
                <button className="btn btn-primary" disabled={saving}>{saving ? "Saving..." : editingId ? "Update Module" : "Save Module"}</button>
                {editingId ? <button type="button" className="btn btn-outline-secondary" onClick={() => { setEditingId(null); setForm({ academy_category: "", name: "", description: "", is_active: true }); }}>Cancel Edit</button> : null}
              </div>
            </form>
          </div>
        </div>

        <div className="card shadow-sm border-0">
          <div className="card-body">
            <div className="row g-3 mb-3">
              <div className="col-md-4">
                <select className="form-select" value={filters.academy_category} onChange={(e) => setFilters((prev) => ({ ...prev, academy_category: e.target.value }))}>
                  <option value="">All Academy Categories</option>
                  {academyCategories.map((item) => <option key={item} value={item}>{item}</option>)}
                </select>
              </div>
              <div className="col-md-5">
                <input className="form-control" placeholder="Search module" value={filters.search} onChange={(e) => setFilters((prev) => ({ ...prev, search: e.target.value }))} />
              </div>
              <div className="col-md-3">
                <button className="btn btn-outline-dark w-100" onClick={loadRows} disabled={loading}>{loading ? "Loading..." : "Apply Filter"}</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Academy Category</th>
                    <th>Module</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.academy_category || "-"}</td>
                      <td>{item.name}</td>
                      <td>{item.description || "-"}</td>
                      <td><span className={`badge ${item.is_active ? "bg-success" : "bg-secondary"}`}>{item.is_active ? "Active" : "Inactive"}</span></td>
                      <td>
                        <div className="d-flex gap-2">
                          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => { setEditingId(item.id); setForm({ academy_category: item.academy_category || "", name: item.name || "", description: item.description || "", is_active: Boolean(item.is_active) }); window.scrollTo({ top: 0, behavior: "smooth" }); }} title="Edit">
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => deleteItem(item.id)} title="Delete">
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {!rows.length && <tr><td colSpan="6" className="text-center text-muted py-4">No course module found.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default CourseModuleManager;
